import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input,
    EventEmitter, Output} from '@angular/core';
import {fadeInAnimation, fadeInOut} from '../../common/service/routerTransition';
import {TranslateService} from '@ngx-translate/core';
import { DialogService } from '../../common/service/dialog.service';
import { Constant } from '../../common/constant';
import { ShortcutService } from '../../common/service/shortcut.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
declare let $: any;

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.html',
    styleUrls: [
        'confirm.dialog.scss'
    ],
    animations: [fadeInAnimation, fadeInOut],
    host: {'[@fadeInAnimation]': ''}
  })
  
export class ConfirmDialogComponent implements OnInit {
    @Input('header') header;
    @Input('title') title;
    @Input('buttonLabel') buttonLabel;
    @Input('buttonCancelLabel') buttonCancelLabel;
    @Output() result: EventEmitter<any> = new EventEmitter();
    Constant = Constant;
    @Input('func') func: any;
    @Input('cancelFunc') cancelFunc: any;
    @Input('config') config: any = {};
    constructor(
        public eventManger: EventManagerService,
        public activeModal: NgbActiveModal,
    ) {
    }
    ngOnInit() {
        this.eventManger.subscribe('close-confirm-dialog', () => {
            this.activeModal.dismiss();
        })
    }
    argree() {
        this.dismiss();
        if (this.func) {
            this.func();
        } else this.result.emit(true);
    }
    cancel() {
        this.dismiss();
        if (this.cancelFunc) {
            this.cancelFunc();
        } else this.result.emit(false)
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}